import { useQuery } from "react-query";
import URL from "core/resources/urls";
import http from "infra/http";

function useGetInsumos(idExternoComponente: string, idExternoUnidade?: string) {
  return useQuery(
    [URL.ORDEM_SERVICO.INSUMOS, idExternoComponente, idExternoUnidade],
    async () => {
      const { data } = await http.get(URL.ORDEM_SERVICO.INSUMOS(idExternoComponente, idExternoUnidade));
      return data;
    },
    {
      enabled: !!idExternoComponente && !!idExternoUnidade,
    }
  );
}

export default useGetInsumos;
